import React from 'react';
import { Box } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../Redux/hooks';
import { toggleLoanFilter } from '../../../Redux/cryptoFilterSlice';

const LoanEligibleToggle: React.FC = () => {
    const dispatch = useAppDispatch();
    const showOnlyLoanEligible = useAppSelector((state) => state.cryptoFilter.showOnlyLoanEligible);

    const handleToggle = () => {
        dispatch(toggleLoanFilter());
    };

    return (
        <Box
            onClick={handleToggle}
            sx={{
                position: 'relative',
                width: '48px',
                height: '24px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
            }}
        >
            {/* Background Track */}
            <Box
                sx={{
                    position: 'absolute',
                    width: '48px',
                    height: '16px',
                    background: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '12.6316px',
                    transition: 'background 0.3s ease',
                }}
            />

            {/* Toggle Circle */}
            <Box
                sx={{
                    position: 'absolute',
                    width: '24px',
                    height: '24px',
                    background: showOnlyLoanEligible ? '#F2674A' : 'dimgrey',
                    borderRadius: '50%',
                    left: showOnlyLoanEligible ? '24px' : '0px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    transition: 'all 0.3s ease',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                }}
            >
                <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M0 16L3.00841 11.0694H0.453326L3.29687 6.42901H0.164871L4.40949 0H8L4.9453 4.01205L7.88887 3.91541L4.23253 9.136H7.12945L0 16Z"
                        fill="url(#paint0_linear_5557_11904)"
                    />
                    <defs>
                        <linearGradient id="paint0_linear_5557_11904" x1="4" y1="8.20062e-08" x2="-1.3443" y2="15.5376" gradientUnits="userSpaceOnUse">
                            <stop stopColor="#EEA415" />
                            <stop offset="1" stopColor="#FFD25E" />
                        </linearGradient>
                    </defs>
                </svg>
            </Box>
        </Box>
    );
};

export default LoanEligibleToggle;